module.exports = __webpack_public_path__ + "img/payments2.6d7b192c.jpg";